import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    monthPickerWell: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: 4.5,
        paddingBottom: 4.5,
        marginBottom: 10
    },
    monthPickerInner: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12
    },
    monthPickerLabel: {
        marginRight: 5
    },
    sectionPanel: {
        marginBottom: 10
    },
    subGroupHeading: {
        backgroundColor: 'ghostwhite',
        padding: '7.5px 15px'
    },
    issueList: {
        marginTop: 5,
        marginBottom: 0,
        listStyleType: 'disc'
    },
    flushListGroup: {
        marginBottom: 0
    },
    centerIssues: {
        marginBottom: 15
    },
    centerIssuesTitle: {
        marginBottom: 5
    },
    summary: {
        fontWeight: 'bold',
        marginBottom: 10
    },
};
